<template>
  <div>

    <div class="module-top">
      <div class="inner animate__animated animate__fadeIn">关于我们</div>
      <img class="aboutUs-bg" :src="aboutUsTopBg" alt="">
    </div>
    <div class="module-list">
      <div style="height:300px"></div>
      <div class="company-introduce  animate__animated animate__fadeIn">
        <div class="module-item" style="padding-top:0">
          <div class="activity-tab">
            <div class="title">
              <span>公司简介</span>
            </div>
          </div>
          <div class="introduce-content">
            <p>未斯科技通过践行科技让物流更智能这一使命,综合运用RPA机器人、aPaaS低代码平台和AI人工智能技术为国际物流行业数字化转型提供了一站式智能化产品及解决方案,并基于行业特性打造了e航无忧™产品套件,帮助国际物流企业全面提升内部工作效率,有效降低运营成本,缩短日常操作链路,以实现业务的自动化、数字化和智能化。</p>
            <p>未来,我们将致力于企业数智化转型升级,通过不断的产品研发和技术创新帮助其提升协作效率、降低运营成本，在新时代、新理念和新技术的驱动下探索更高效、更便捷的企业管理和经营方式,为他们创造更大的商业价值,并与中国数智化时代同行。</p>
          </div>
        </div>
      </div>

      <div class="module-item company-develop">
        <ActivityTitle title="发展历程" />
        <div class="develop-content">
          <div class="develop-timeline">
            <div class="develop-arrow"></div>
            <div class="develop-nodes">
              <ul class="nodes-top">
                <li class="top-timeline-item" style="margin-left:124px">
                  <div class="timeline-node"></div>
                  <div class="timeline-wrapper">
                    <div class="timeline-timestamp">2020年5月</div>
                    <div class="timeline-content">国际物流平台“e航无忧”<br>第一版线下发布</div>
                  </div>
                </li>
                <li class="top-timeline-item" style="margin-left:194px">
                  <div class="timeline-node"></div>
                  <div class="timeline-wrapper">
                    <div class="timeline-timestamp">2020年12月</div>
                    <div class="timeline-content">获得“元璟资本”和“良仓基金”<br>千万级天使轮融资</div>
                  </div>
                </li>
                <li class="top-timeline-item" style="margin-left:156px">
                  <div class="timeline-node"></div>
                  <div class="timeline-wrapper">
                    <div class="timeline-timestamp">2021年8月</div>
                    <div class="timeline-content">入选2021年度中国（杭州）人工智能板块政府<br>重点扶持创新型项目，三年600万研发经费补贴</div>
                  </div>
                </li>
              </ul>
              <ul class="nodes-bottom">
                <li class="bottom-timeline-item">
                  <div class="timeline-node"></div>
                  <div class="timeline-wrapper">
                    <div class="timeline-timestamp">2020年初</div>
                    <div class="timeline-content">公司在上海成立</div>
                  </div>
                </li>
                <li class="bottom-timeline-item" style="margin-left:220px">
                  <div class="timeline-node"></div>
                  <div class="timeline-wrapper">
                    <div class="timeline-timestamp">2020年12月</div>
                    <div class="timeline-content">公司用户数量突破100家</div>
                  </div>
                </li>
                <li class="bottom-timeline-item" style="margin-left:245px">
                  <div class="timeline-node"></div>
                  <div class="timeline-wrapper">
                    <div class="timeline-timestamp">2021年8月</div>
                    <div class="timeline-content">RPA机器人产品套件<br>UiFox正式上线</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="module-item company-hope">
        <ActivityTitle title="使命·愿景" />
        <div class="hope-content">
          <div class="hope-item hope-t-item" style="margin-right:20px">
            <div class="hope-item-bg"></div>
            <div class="hope-item-content">
              <p class="hope-item-title">科技让物流更智能</p>
              <p class="hope-item-desc">Technology makes logistics more intelligent</p>
            </div>
          </div>
          <div class="hope-item hope-l-item">
            <div class="hope-item-bg"></div>
            <div class="hope-item-content">
              <p class="hope-item-title">引领数智化物流新时代</p>
              <p class="hope-item-desc">Leading the new era of digitalized logistics</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActivityTitle from "./components/ActivityTitle.vue"
export default {
  name: "index",
  components: { ActivityTitle },
  data () {
    return {
      bannerList: [],
      showIndex: null,
      activeIndex: 1,
      userData: null,
      aboutUsTopBg: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/user/home/aboutUs-top-s.png',
    }
  },
  mounted () {

  },
  methods: {
    mouseOver (index) {
      this.showIndex = index
    }
  }
}
</script>

<style scoped lang="less">
.module-top {
  height: 480px;
  background: url("https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/aboutUs-top-bg.png")
    no-repeat;
  background-size: 100% 100%;
  position: relative;

  .aboutUs-bg {
    width: 400px;
    position: absolute;
    top: 116px;
    left: 50%;
    transform: translateX(200px);
  }

  .inner {
    width: 100%;
    height: 100%;
    font-size: 38px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 300px;
    letter-spacing: 6px;
    text-align: center;
    position: relative;
  }
}
.module-list {
  box-sizing: border-box;
  position: relative;
  .module-item {
    padding-top: 48px;
    box-sizing: border-box;
    position: relative;
    .activity-tab {
      height: 112px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      .title {
        font-size: 32px;
        font-weight: bold;
        color: #222222;
        display: flex;
        align-items: center;
        span {
          padding: 0 24px;
        }
        img {
          width: 32px;
          height: 11px;
        }
      }
    }
  }
  .company-introduce {
    width: 1200px;
    height: 350px;
    position: absolute;
    top: -164px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 16px;
    overflow: hidden;
    background-color: #ffffff;
    .introduce-content {
      width: 1048px;
      margin: 0 auto;
      p {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 28px;
        letter-spacing: 2px;
        margin-bottom: 20px;
        text-align: justify;
      }
    }
  }
  .company-develop {
    background: url("https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/aboutUs-banner.png")
      no-repeat;
    background-size: 100% 100%;
    height: 596px;
    margin-bottom: 40px;
    .develop-content {
      position: relative;
      height: 396px;
    }
    .develop-timeline {
      width: 1188px;
      height: 3px;
      background-image: linear-gradient(45deg, #1170eb, #e7f0fd);
      position: absolute;
      bottom: 244px;
      left: 50%;
      margin-left: -594px;
      .develop-arrow {
        height: 0px;
        width: 0px;
        border-top: 9px solid transparent;
        border-left: 13px solid #82dfffff;
        border-bottom: 9px solid transparent;
        position: absolute;
        right: -6px;
        top: -8px;
      }
      .timeline-node {
        width: 19px;
        height: 19px;
        background: #1874ec;
        border-radius: 50%;
        margin-bottom: 14px;
        overflow: hidden;
        animation: mymove 1s infinite;
        -webkit-animation: mymove 3s infinite; /*Safari and Chrome*/
        animation-direction: alternate; /*轮流反向播放动画。*/
        animation-timing-function: ease-in-out; /*动画的速度曲线*/
        -webkit-animation: mymove 1s infinite;
        -webkit-animation-direction: alternate; /*轮流反向播放动画。*/
        -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
      }
      @keyframes mymove {
        0% {
          box-shadow: 0 0 0 5px rgba(114, 211, 255, 0);
        }
        20% {
          box-shadow: 0 0 0 5px rgba(114, 211, 255, 0.1);
        }
        40% {
          box-shadow: 0 0 0 5px rgba(114, 211, 255, 0.2);
        }
        60% {
          box-shadow: 0 0 0 5px rgba(114, 211, 255, 0.3);
        }
        80% {
          box-shadow: 0 0 0 5px rgba(114, 211, 255, 0.4);
        }
        100% {
          box-shadow: 0 0 0 5px rgba(114, 211, 255, 0.8);
        }
      }
      @-webkit-keyframes mymove {
        /*Safari and Chrome*/
        0% {
          box-shadow: 0 0 0 5px rgba(114, 211, 255, 0);
        }
        20% {
          box-shadow: 0 0 0 5px rgba(114, 211, 255, 0.1);
        }
        40% {
          box-shadow: 0 0 0 5px rgba(114, 211, 255, 0.2);
        }
        60% {
          box-shadow: 0 0 0 5px rgba(114, 211, 255, 0.3);
        }
        80% {
          box-shadow: 0 0 0 5px rgba(114, 211, 255, 0.4);
        }
        100% {
          box-shadow: 0 0 0 5px rgba(114, 211, 255, 0.8);
        }
      }
      .timeline-timestamp {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
      }
      .timeline-content {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        letter-spacing: 1px;
        line-height: 24px;
      }
      .nodes-bottom {
        position: absolute;
        top: -8px;
      }
      .bottom-timeline-item,
      .top-timeline-item {
        float: left;
      }
      .nodes-top {
        position: absolute;
        top: -8px;
        .timeline-node {
          background: #1874ec;
          //outline: rgba(114, 211, 255, 0.3) solid 5px;
          box-shadow: 0 0 0 5px rgba(114, 211, 255, 0.3);
        }
        .timeline-wrapper {
          position: relative;
          top: -122px;
        }
      }
    }
  }
  .company-hope {
    height: 550px;
    padding-top: 20px;
    .hope-content {
      width: 1200px;
      margin: 0 auto;
    }
    .hope-item {
      width: 590px;
      height: 280px;
      background: #ffffff;
      box-shadow: 0px 10px 50px 1px rgba(201, 213, 255, 0.52);
      border-radius: 24px;
      float: left;
      position: relative;
    }
    .hope-t-item .hope-item-bg {
      background: url("https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/hope-t-bg.png")
        no-repeat;
      background-size: 101px 106px;
      width: 101px;
      height: 106px;
      top: 84px;
      left: 171px;
      position: absolute;
    }
    .hope-l-item .hope-item-bg {
      background: url("https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/hope-l-bg.png")
        no-repeat;
      background-size: 85px 106px;
      width: 85px;
      height: 106px;
      top: 84px;
      left: 183px;
      position: absolute;
    }
    .hope-item-content {
      text-align: center;
      margin-top: 125px;
    }
    .hope-item-title {
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1170eb;
      line-height: 25px;
      margin-bottom: 20px;
    }
    .hope-item-desc {
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 25px;
    }
  }
}
</style>